// DS9.4.1, DS9.4.1M
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { getCoverImageAttributes } from '../../Thumb/helpers';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import PromoBadgeWithTooltip from '../../../PromoBadgeWithTooltip';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import TextRenderer from '../../../TextRenderer';
import JournalViewer from '../../../DaEditorWrapper/Viewer/Journal';
import ReadingTime from '../_partials/ReadingTime';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import { DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH, DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT } from '../constants';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../feedcard.legacy.theme.scss';
import s from './Journal.scss';
const JournalFeedCardContents = ({ className, deviation, extraActions, withWatchOrSubscribeButton, withCommentSuggestions })=>{
    const coverImage = getCoverImageAttributes({
        deviation,
        width: DEFAULT_COVER_IMAGE_RESOLUTION_WIDTH,
        height: DEFAULT_COVER_IMAGE_RESOLUTION_HEIGHT,
        allowHuge: true
    });
    const { tier, isUserSubscribed, needsSubscription, isSubscribedButBlocked } = useSubscriptionTier(deviation);
    // maintain this so we can track when we can enable scroll restoration on duperbrowse
    const [isLayoutReady, setIsLayoutReady] = useState(false);
    const onLayoutReady = useCallback(()=>{
        setIsLayoutReady(true);
    }, []);
    return /*#__PURE__*/ React.createElement(FeedCardLayout, {
        className: className,
        deviation: deviation,
        extraActions: extraActions,
        isExpandable: true,
        // we need to force the toggle button to be shown when unsubscribed/blocked
        // because the BE truncates text and the content is never tall enough to
        // cause the toggle to be shown using the normal means
        forceShowExpansionToggle: needsSubscription || isSubscribedButBlocked,
        withCommentControl: true,
        withFaveControl: true,
        withWatchOrSubscribeButton: withWatchOrSubscribeButton,
        withCommentSuggestions: withCommentSuggestions,
        onLayoutReady: onLayoutReady
    }, coverImage && /*#__PURE__*/ React.createElement("div", {
        className: s['cover-image'],
        style: _object_spread({}, coverImage.style)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['fade']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title-area']
    }, !!tier && (isUserSubscribed ? /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40,
        className: s['tier-badge']
    }) : /*#__PURE__*/ React.createElement(PromoBadgeWithTooltip, {
        badgeType: "tier",
        size: 40,
        className: s['tier-badge'],
        isLocked: !isUserSubscribed
    })), /*#__PURE__*/ React.createElement(FeedCardTitle, {
        className: s['title'],
        deviation: deviation,
        disableScrollRestoration: !isLayoutReady
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['reading-time']
    }, /*#__PURE__*/ React.createElement(ReadingTime, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement(TextRenderer, {
        textContent: deviation.textContent,
        reactViewer: JournalViewer,
        viewerKey: deviation.deviationId,
        legacyTheme: "journal",
        fixedParagraph: false,
        // if we don't turn off lazy loading here, tall images won't load src when this is collapsed
        disableLazyLoading: true,
        draftjsThemeOverride: draftTheme,
        className: classnames(s['content'], needsSubscription && s['show-at-least-two-lines'], legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'])
    }));
};
JournalFeedCardContents.displayName = 'JournalFeedCardContents';
export default JournalFeedCardContents;

//# sourceMappingURL=Journal.js.map